import { useKeycloak } from '@react-keycloak/web'
import PropTypes from 'prop-types'
import { env } from '../../../../env.js'
import { Icons } from '../Icons.jsx'

const NieMaszDostepu = () => {
    return (
        <div
            className={
                'fs-4 bold min-vh-100 min-vw-100 d-flex flex-column justify-content-center align-items-center'
            }
        >
            <Icons.forbidden size={100} />
            <div>Nie masz dostępu do tego zasobu</div>
        </div>
    )
}

const AuthorizedView = (props) => {
    const { keycloak, initialized } = useKeycloak()
    const kcRoles =
        keycloak?.tokenParsed?.resource_access?.[env.RESOURCE_REALM]?.roles
    const hasAnyRole = () =>
        initialized && props?.roles?.some((r) => kcRoles?.includes(r))

    const hasAllRoles = () =>
        initialized && props?.roles?.every((r) => kcRoles?.includes(r))

    if (props?.roles?.some((r) => Boolean(r) === false)) {
        return <NieMaszDostepu />
    } else if (!!props?.roles && props.mode === 'pass') {
        return props.children
    } else if (props.mode === 'all' && hasAllRoles()) {
        return props.children
    } else if (props.mode === 'any' && hasAnyRole()) {
        return props.children
    } else {
        return <NieMaszDostepu />
    }
}

AuthorizedView.propTypes = {
    children: PropTypes.any.isRequired, //@komponent do wy
    roles: PropTypes.array.isRequired, //@tablica ról oczekiwanych
    forbidden: PropTypes.any, //@ komponent wyświetlany gdy użytkownik nie ma dostępu (opcjonalnie)
    mode: PropTypes.oneOf(['all', 'any', 'pass']).isRequired, //@all - wszystkie role, any - przynajmniej jedna, pass - nie sprawdzaj
}

//@ przykład użycia
// <AuthorizedView roles={["a","b", "c"]} mode={"any"}/>
// <AuthorizedView roles={["a","b", "c"]} mode={"all"}/>
// <AuthorizedView mode={"pass"}/>

export default AuthorizedView
